import React from "react";
import { Link, useHistory } from "react-router-dom";

const GameCards = () => {
  const navigate = useHistory();
  const handleRedirect = (path) => {
    navigate.push(path);
  };
  return (
    <div>
      <div className="homepage-game-cards">
        <div className="homepage-game-cards-grid-1">
          <button
            className="casino-home-gamecard"
            // onClick={() => handleRedirect("/casino")}
          >
            <img
              className="casino-home-gamecard-img"
              src="/assets/bcimages/bchome/casino-game-card.webp"
            />
            <div className="casino-home-gamecard-contant">
              <div className="casino-home-gamecard-top">
                <img
                  style={{ height: "2rem", width: "2rem", flex: "none" }}
                  src="/assets/bcimages/bchome/casino-home-gamecard.svg"
                />
                <span className="text-sm ml-0.5 sm:text-2xl">Original</span>
              </div>
              <div className="casino-home-gamecard-bottom">
                Dive into our in-house games
              </div>
            </div>
          </button>

          <button
            className="sports-home-gamecard"
            // onClick={() => handleRedirect("/casino/sports")}
          >
            <img
              className="sports-home-gamecard-img"
              src="/assets/bcimages/bchome/sports-game-card.webp"
            />
            <div className="casino-home-gamecard-contant">
              <div className="casino-home-gamecard-top">
                <img
                  style={{ height: "2rem", width: "2rem", flex: "none" }}
                  src="/assets/bcimages/bchome/sports-home-gamecard.svg"
                />
                <span className="text-sm ml-0.5 sm:text-2xl">Big Wins</span>
              </div>
              <div className="casino-home-gamecard-bottom">
                Play In-House, Win Big
              </div>
            </div>
          </button>
        </div>

        <div className="homepage-game-cards-grid-2">
          <button
            className="lottery-home-gamecard"
            onClick={() => handleRedirect("/crash")}
          >
            <img
              className="lottery-home-gamecard-img"
              src="/assets/images/bccrash.png"
            />
            <div className="lottery-home-gamecard-span">
              <img
                style={{ height: "1.5rem", width: "1.5rem", flex: "none" }}
                src="/assets/bcimages/bchome/lottery-home-gamecard.svg"
              />
              <span className="text-sm ml-0.5 sm:text-2xl">Crash</span>
            </div>
          </button>
          <button
            onClick={() => handleRedirect("/blackjack")}
            style={{
              backgroundImage:
                "linear-gradient(to right, rgb(74, 132, 130), rgb(80, 65, 48) 75%)",
            }}
            className="lottery-home-gamecard"
          >
            <img
              className="lottery-home-gamecard-img"
              src="/assets/images/live-card.png"
            />
            <div className="lottery-home-gamecard-span">
              <img
                style={{ height: "1.5rem", width: "1.5rem", flex: "none" }}
                src="/assets/images/bcslots.png"
              />
              <span className="text-sm ml-0.5 sm:text-2xl">RACING</span>
            </div>
          </button>
          <button
            onClick={() => handleRedirect("/casino/hot-games")}
            style={{
              backgroundImage:
                "linear-gradient(to right, rgb(43, 100, 98), rgb(45, 79, 49) 75%)",
            }}
            className="lottery-home-gamecard"
          >
            <img
              className="lottery-home-gamecard-img"
              src="/assets/images/bcslots.png"
            />
            <div className="lottery-home-gamecard-span">
              <img
                style={{ height: "1.5rem", width: "1.5rem", flex: "none" }}
                src="/assets/bcimages/bchome/updown-home-gamecard.svg"
              />
              <span className="text-sm ml-0.5 sm:text-2xl">HotGames</span>
            </div>
          </button>
          <button
            // onClick={() =>
            //   handleRedirect(
            //     "/https://wingo.betbazaar365.com/wingo/?game_type=10"
            //   )
            // }
            style={{
              backgroundImage:
                "linear-gradient(to right, rgb(63, 124, 137), rgb(71, 56, 111) 75%)",
            }}
            className="lottery-home-gamecard"
          >
            <img
              className="lottery-home-gamecard-img"
              src="/assets/images/ezugi-live.png"
            />
            <div className="lottery-home-gamecard-span">
              <img
                style={{ height: "1.5rem", width: "1.5rem", flex: "none" }}
                src="/assets/bcimages/bchome/bingo-home-gamecard.svg"
              />
              <span className="text-sm ml-0.5 sm:text-2xl">WINGO</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameCards;
